<!-- 员工报表 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('StaffReport.title')"
			left-arrow
			fixed
		  	@click-left="$router.go(-1)">
		</van-nav-bar> 
		<van-cell-group>
			<span class="text">{{$t('StaffReport.text1')}}</span>
			<van-field
				class="inputAr"
			  	readonly  	
			  	right-icon="arrow" 	  	
			  	@click="showStartTimePicker = true" 	
			  	:value='staff.startTime'
			/> 
			<!-- 弹框 -->
			<van-popup v-model="showStartTimePicker" position="bottom">
				<van-datetime-picker
				  	v-model="currentDate"
				  	type="date"
				  	:max-date="maxDate"
				  	:confirm-button-text="$t('vantText.confirm')"
			    	:cancel-button-text="$t('vantText.cancel')"
				  	@cancel="showStartTimePicker = false"
				    @change="changeStartTime()"
				    @confirm="onStartChangeConfirm"
				/>
			</van-popup>
			<span class="text">{{$t('StaffReport.text')}}</span>
			<van-field
				class="inputAr"
			  	readonly
			  	right-icon="arrow" 		
			  	@click="showEndTimePicker = true"
			  	:value='staff.endTime'
			/>  
			<!-- 弹框 -->
			<van-popup v-model="showEndTimePicker" position="bottom">
				<van-datetime-picker
				  	v-model="currentEndDate"
				  	type="date"
				  	:min-date="minDate"
				  	:confirm-button-text="$t('vantText.confirm')"
			    	:cancel-button-text="$t('vantText.cancel')"
				  	@cancel="showEndTimePicker = false"
				    @change="changeEndTime()"
				    @confirm="onChangeConfirm"
				/>
			</van-popup>
		</van-cell-group>
		<!-- 分割线 -->
		<div class="divideLine"></div>
		<van-tabs v-model="active" @click=onStaffReport :swipe-threshold=5 :ellipsis='false'>
			<van-tab :title="$t('StaffReport.reserve')" >
				<!-- 表头 -->
				<van-cell>
					<van-row class='title'>
						<van-col span="5" class='rank'>{{$t('StaffReport.rank')}}</van-col>
						<van-col span="14">{{$t('StaffReport.name')}}</van-col>
						<van-col span="5">{{$t('StaffReport.num')}}</van-col>	
					</van-row>
				</van-cell>
				<van-cell v-for="(item,index) in StaffReports" :key='index' >
					<van-row>
						<van-col span="5">{{index+1}}</van-col>
						<van-col span="14">{{item.name}}</van-col>
						<van-col span="5">{{item.book}} {{$t('StaffReport.one')}}</van-col>
					</van-row>
				</van-cell>
			</van-tab>
			<van-tab :title="$t('StaffReport.order')">
				<!-- 表头 -->
				<van-cell>
					<van-row class='title'>
						<van-col span="5" class='rank'>{{$t('StaffReport.rank')}}</van-col>
						<van-col span="14">{{$t('StaffReport.name')}}</van-col>
						<van-col span="5">{{$t('StaffReport.num')}}</van-col>	
					</van-row>
				</van-cell>
				<van-cell v-for="(item,index) in StaffReports" :key='index' >
					<van-row>
						<van-col span="5">{{index+1}}</van-col>
						<van-col span="14">{{item.name}}</van-col>
						<van-col span="5">{{item.order}} {{$t('StaffReport.one')}}</van-col>
					</van-row>
				</van-cell>
			</van-tab>
			<van-tab :title="$t('StaffReport.dishes')">
				<!-- 表头 -->
				<van-cell>
					<van-row class='title'>
						<van-col span="5" class='rank'>{{$t('StaffReport.rank')}}</van-col>
						<van-col span="14">{{$t('StaffReport.name')}}</van-col>
						<van-col span="5">{{$t('StaffReport.num')}}</van-col>	
					</van-row>
				</van-cell>
				<van-cell v-for="(item,index) in StaffReports" :key='index' >
					<van-row>
						<van-col span="5">{{index+1}}</van-col>
						<van-col span="14">{{item.name}}</van-col>
						<van-col span="5">{{item.serving}} {{$t('StaffReport.one')}}</van-col>
					</van-row>
				</van-cell>
			</van-tab>
			<van-tab :title="$t('StaffReport.clean')">
				<!-- 表头 -->
				<van-cell>
					<van-row class='title'>
						<van-col span="5" class='rank'>{{$t('StaffReport.rank')}}</van-col>
						<van-col span="14">{{$t('StaffReport.name')}}</van-col>
						<van-col span="5">{{$t('StaffReport.num')}}</van-col>	
					</van-row>
				</van-cell>
				<van-cell v-for="(item,index) in StaffReports" :key='index' >
					<van-row>
						<van-col span="5">{{index+1}}</van-col>
						<van-col span="14">{{item.name}}</van-col>
						<van-col span="5">{{item.clean}} {{$t('StaffReport.one')}}</van-col>
					</van-row>
				</van-cell>
			</van-tab>
			<van-tab :title="$t('StaffReport.settleAccounts')">
				<!-- 表头 -->
				<van-cell>
					<van-row class='title'>
						<van-col span="5" class='rank'>{{$t('StaffReport.rank')}}</van-col>
						<van-col span="14">{{$t('StaffReport.name')}}</van-col>
						<van-col span="5">{{$t('StaffReport.num')}}</van-col>	
					</van-row>
				</van-cell>
				<van-cell v-for="(item,index) in StaffReports" :key='index' >
					<van-row>
						<van-col span="5">{{index+1}}</van-col>
						<van-col span="14">{{item.name}}</van-col>
						<van-col span="5">{{item.settle}} {{$t('StaffReport.one')}}</van-col>
					</van-row>
				</van-cell>
			</van-tab>
		</van-tabs>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				active: 0,
  				staff:{
  					startTime:this.formatDateYMD1(new Date()),
  					endTime:this.formatDateYMD(new Date())
  				},
  				StaffReports:[],
  				maxDate:new Date(),
  				minDate:new Date(),
  				currentDate:new Date(),
  				currentEndDate:new Date(),
  				showStartTimePicker:false,
  				showEndTimePicker:false,
  				book:'book',
  				order:'order',
  				serving:'serving',
  				clean:'clean',
  				settle:'settle'
  			}
  		},
  		mounted:function(){
  			// this.staff.startTime=this.formatDateYMD(new Date());
  			// this.staff.endTime=this.formatDateYMD(new Date());
  			this.getStaffDate(this.book);
	    },
	    methods:{
	    	getStaffDate(Type){
	    		this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/staffService',
	                data:{
	                	startday:this.staff.startTime,
	                	endday:this.staff.endTime,
	                	type:Type
	                }
	            }).then(res => {
	            	if(res.data.status==200){
	                	this.StaffReports=res.data.data;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	//点击结束日期
	    	onChangeConfirm(){
				this.staff.endTime=this.formatDateYMD(this.currentEndDate);
	    		this.showEndTimePicker = false;
	    		// 点击确定按钮后，根据当前状态刷新对应的数据
	    		this.changeStatus();
	    	},
	    	//点击开始日期
	    	onStartChangeConfirm(){
	    		this.staff.startTime=this.formatDateYMD(this.currentDate);
	    		this.showStartTimePicker = false;
	    		this.changeStatus();
	    	},
	    	//开始时间显示前一个月
	    	formatDateYMD1(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear();
			        var M = (date.getMonth()+1);
			        var D = date.getDate();

			        //获取前一个月的日期
			        var Y2=Y;
			        var M2=parseInt(M) - 1;
			        //如果月为0则显示去年最后一个月12月
			        if(M2==0){
			        	Y2 = parseInt(Y2) - 1;
        				M2 = 12;
			        }
			        var D2=D;
			        var DS2=new Date(Y2, M2, 0); 
			        DS2=DS2.getDate(); 
			        if(D2>DS2){
			        	D2=DS2
			        }
			        if(M2<10){
			        	M2=M2;
			        }
			        var t2=Y2 + '/' + M2 + '/' + D2;
			        return t2;
			    }
			},
	    	formatDateYMD(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear()+'/';
			        var M = (date.getMonth()+1)+ '/';
			        var D = date.getDate();
			        return Y+M+D;
			    }
			},
			changeStartTime(){
				this.staff.startTime=this.formatDateYMD(this.currentDate);
				this.minDate=this.currentDate;
			},
			changeEndTime(){
				this.staff.endTime=this.formatDateYMD(this.currentEndDate);
				this.maxDate=this.currentEndDate;
			},
			//点击相应标签时，刷新对应数据
			onStaffReport(name,title){
				if(title== this.$t('StaffReport.reserve')){
					this.getStaffDate(this.book);
				}else if(title == this.$t('StaffReport.order')){
					this.getStaffDate(this.order);
				}else if(title == this.$t('StaffReport.dishes')){
					this.getStaffDate(this.serving)	
				}else if(title == this.$t('StaffReport.clean')){
					this.getStaffDate(this.clean)
				}else{
					this.getStaffDate(this.settle)
				}
			},
			changeStatus(){
				// 点击确定按钮后，根据当前状态刷新对应的数据
	    		if(this.active==0){
	    			this.getStaffDate(this.book);
	    		}else if(this.active==1){
	    			this.getStaffDate(this.order);
	    		}else if(this.active==2){
	    			this.getStaffDate(this.serving);
	    		}else if(this.active==3){
	    			this.getStaffDate(this.clean);
	    		}else{
	    			this.getStaffDate(this.settle);
	    		}
			},
	    }
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell{
		line-height: 24px;
	}
	/deep/ .van-tabs__line{
		background-color: #fd3f3f;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7
	}
	/deep/ .van-field__right-icon{
		margin-right:-10px;
		padding:0 5px;
	}
	/deep/ .van-tab{
		white-space: normal
	}
	/*分割线*/
	.divideLine{
		height: 5px;
		background: #F3F5F7;
	}
	.van-cell-group{
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}
	.inputAr{
		width: 40%;
		/*height: 35px;*/
		line-height: 15px;
		border: 2px solid #000;
		border-radius: 50px;
		font-size: 14px;
	}
	/* 至 */
	.text{
		line-height: 35px
	}
	.title{
		font-size: 14px;
		color: #444;
	}
</style>


// WEBPACK FOOTER //
// src/Report/StaffReport.vue